/* atb-quick-find-teaser — home card. Fetches the quiz config (same endpoint +
 * sessionStorage cache as the full quiz), renders the FIRST question's options
 * inline, and on "Continue" sends the shopper to the quiz page with that answer
 * pre-filled (?a1=<value>) so they land on question 2. Degrades to a plain link
 * to the quiz if the config can't load. */
(function () {
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function init(mount) {
    var slug = mount.getAttribute("data-atb-qft-slug") || "default";
    var proxy = (mount.getAttribute("data-atb-qft-proxy") || "https://app.adamstoybox.com/api/quick-find").replace(/\/+$/, "");
    var quizUrl = mount.getAttribute("data-atb-qft-quiz-url") || "/pages/quick-find";
    var headEl = mount.querySelector("[data-atb-qft-head]");
    var choicesEl = mount.querySelector("[data-atb-qft-choices]");
    var continueBtn = mount.querySelector("[data-atb-qft-continue]");
    var tpl = mount.querySelector("[data-atb-qft-choice-tpl]");
    if (!choicesEl || !continueBtn) return;

    var selected = null;
    var q1Id = null;
    var ck = "atb_qf_cfg_" + slug; // shared cache key with the full quiz

    // Analytics — same session id ("atb_qf_sid") + endpoint as the full quiz, so the
    // home card shows as the top of one funnel (teaser_view -> teaser_continue -> quiz).
    function sid() {
      try {
        var k = "atb_qf_sid", v = sessionStorage.getItem(k);
        if (!v) { v = Date.now().toString(36) + Math.random().toString(36).slice(2, 8); sessionStorage.setItem(k, v); }
        return v;
      } catch (e) { return "anon"; }
    }
    function device() {
      var w = window.innerWidth || screen.width || 0;
      if (w && w < 600) return "mobile";
      if (w && w < 1024) return "tablet";
      return "desktop";
    }
    function beacon(eventType, extra) {
      try {
        fetch(proxy + "/analytics", {
          method: "POST", headers: { "Content-Type": "application/json" }, keepalive: true,
          body: JSON.stringify(Object.assign({ eventType: eventType, sessionId: sid(), device: device() }, extra || {})),
        });
      } catch (e) {}
    }
    beacon("teaser_view");

    function loadConfig() {
      try { var c = sessionStorage.getItem(ck); if (c) return Promise.resolve(JSON.parse(c)); } catch (e) {}
      return fetch(proxy + "/config?slug=" + encodeURIComponent(slug), { credentials: "same-origin" })
        .then(function (r) { if (!r.ok) throw new Error("config"); return r.json(); })
        .then(function (cfg) { try { sessionStorage.setItem(ck, JSON.stringify(cfg)); } catch (e) {} return cfg; });
    }

    continueBtn.addEventListener("click", function () {
      if (continueBtn.disabled) return;
      beacon("teaser_continue", { questionId: q1Id, answerValue: selected });
      var href = quizUrl;
      if (selected) href = quizUrl + (quizUrl.indexOf("?") >= 0 ? "&" : "?") + "a1=" + encodeURIComponent(selected);
      window.location.href = href;
    });

    function select(val, node) {
      selected = val;
      var all = choicesEl.querySelectorAll(".atb-qft__choice");
      for (var i = 0; i < all.length; i++) { all[i].classList.remove("is-selected"); all[i].setAttribute("aria-checked", "false"); }
      node.classList.add("is-selected"); node.setAttribute("aria-checked", "true");
      continueBtn.disabled = false;
      beacon("teaser_answer", { questionId: q1Id, answerValue: val });
    }

    function render(cfg) {
      var q1 = cfg && cfg.questions && cfg.questions[0];
      if (!q1 || !q1.options || !q1.options.length) { fallback(); return; }
      q1Id = q1.id || null;
      // Heading is rendered server-side (no flash) — only the OPTIONS are filled from config.
      choicesEl.innerHTML = "";
      q1.options.forEach(function (o) {
        var node = tpl ? tpl.content.firstElementChild.cloneNode(true) : document.createElement("button");
        node.setAttribute("data-val", o.value);
        var em = node.querySelector("[data-atb-qft-emoji]");
        var lb = node.querySelector("[data-atb-qft-label]");
        if (em) { if (o.emoji) em.textContent = o.emoji; else em.remove(); }
        if (lb) lb.textContent = o.label || o.value;
        node.addEventListener("click", function () { select(o.value, node); });
        choicesEl.appendChild(node);
      });
      continueBtn.disabled = true;
    }

    // Config unavailable: keep the card useful — Continue just opens the quiz.
    function fallback() {
      choicesEl.innerHTML = "";
      selected = null;
      continueBtn.disabled = false;
    }

    loadConfig().then(render).catch(fallback);
  }

  function boot() {
    document.querySelectorAll("[data-atb-qft]").forEach(function (m) {
      if (m.dataset.atbQftWired === "1") return;
      m.dataset.atbQftWired = "1";
      try { init(m); } catch (e) { console.warn("[atb-qft]", e); }
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
